
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const MoreOptions = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <circle cx="12.5" cy="12.5" r="1.7"></circle>
            <circle cx="12.5" cy="6.1" r="1.7"></circle>
            <circle cx="12.5" cy="18.9" r="1.7"></circle>
          </g>
        </g>
      </g>
    </IconBase>);
};

MoreOptions.defaultProps = {
  title: 'More Options',
};

export default MoreOptions;
